import { useEffect, useState } from "react";

import { getToken } from "../../helpers/common";
import { useUserDetails } from "../../context/UserDetailContext";

const useProfile = () => {
  const { userDetails } = useUserDetails();
  var token = getToken();
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState(userDetails);


  useEffect(() => {
    var token = getToken();
    setUserProfile(userDetails);
    setLoading(token ? false : true);
  }, [userDetails]);

  return { userProfile, loading, token };
};

export { useProfile };